import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import * as Data from "../Data";
import * as DatiRCP from "../DatiRCP";
import {
    ChiamaAPI,
    Trad,
    BaseComponent,
    Tipo,
    BottoneAPI,
    CampiPolizza,
    InputData,
    CheckListFile,
    AccordionAnagrafica,
    ComparatoreStudioAssociato,
    ComparatoreProfessioneSingola
} from "../components/";
import { CGaranzia } from "../DatiRCP";
import { utc } from "moment";
import moment from "moment";
import { object, bool } from "prop-types";

interface IRCPComparatoreNewState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore;
    AnagraficaJSON: Glob.DatiJSON;
    RecapitiJSON: Glob.DatiJSON;
    IndirizziJSON: Glob.DatiJSON;
    DatoRCPPolizza: any;
    PolizzeJSON: Glob.DatiJSON;
    GaranzieJSON: Glob.DatiJSON;
    FileJSON: Glob.DatiJSON;
    Frazionamento: number;
    DatiProfessionaliJSON: Glob.DatiJSON;
    PreventivoSelezionato: boolean;
    ID_Polizza: number;
    DatiTipoProdotto: Dati.CDatiTipoProdotto;
    //POLIZZA ASSOCIATI
    DatiAssociati: Glob.DatiJSON | DatiRCP.CComparatoreSingolo[];
}

export class RCPComparatoreNew extends BaseComponent<Glob.IRouteGlobaleProps, IRCPComparatoreNewState> {
    private _URLInfoProdottoBase: string = "/api/polizza/GetInfoPolizza?ID_TipoProdotto=";
    private _URLInfoProdotto: string = this._URLInfoProdottoBase + "0";
    private _URLDatiProdottoIncremento: number = 0;
    private _AbilitaModifica: boolean = true;
    private _Frazionamento: Dati.TDictTipo = {};
    private _TipoConsolidamento: string = "";
    private _Differenze: number = 0;
    private _CalcolaRCP: number = 0;

    constructor(props: any) {
        super(props);

        let datiPolizzaBase: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = new DatiRCP.CRisAPIDatoTipiInfo_Comparatore();

        if ((this.props.match.params as any).ID_Anag != undefined) {
            datiPolizzaBase.Dato.ID_AnagContraente = (this.props.match.params as any).ID_Anag;
        } else {
            datiPolizzaBase.Dato.ID_AnagContraente = 0;
        }

        this.state = {
            Caricamento: false,
            Aggiornare: 1,
            Dati: datiPolizzaBase,
            AnagraficaJSON: "",
            RecapitiJSON: "",
            IndirizziJSON: "",
            DatoRCPPolizza: "",
            PolizzeJSON: "",
            GaranzieJSON: "",
            FileJSON: "",
            Frazionamento: 12,
            DatiProfessionaliJSON: "",
            PreventivoSelezionato: false,
            ID_Polizza: -1,
            DatiTipoProdotto: new Dati.CDatiTipoProdotto(),
            DatiAssociati: "[]"
        };

        this.OnChange = this.OnChange.bind(this);

        this.OnRisSelezioneProdotto = this.OnRisSelezioneProdotto.bind(this);

        this.OnModificaURLDatiProdotto = this.OnModificaURLDatiProdotto.bind(this);

        this.OnRisDatiProdotto = this.OnRisDatiProdotto.bind(this);

        this.OnChangeGaranzia = this.OnChangeGaranzia.bind(this);

        this.OnRisProdotto = this.OnRisProdotto.bind(this);

        this.OnRisCalcolaPolizze = this.OnRisCalcolaPolizze.bind(this);

        this.OnRisRecuperaPreventivo = this.OnRisRecuperaPreventivo.bind(this);

        this.OnRisRegola = this.OnRisRegola.bind(this);

        this.OnChangeDataEffetto = this.OnChangeDataEffetto.bind(this);

        this.PopolaFrazionamento = this.PopolaFrazionamento.bind(this);

        this.OnChangeAnagrafica = this.OnChangeAnagrafica.bind(this);

        this.OnRisAnagrafica = this.OnRisAnagrafica.bind(this);

        this.OnInvioSalvaPolizza = this.OnInvioSalvaPolizza.bind(this);

        this.OnClickSalvaPolizza = this.OnClickSalvaPolizza.bind(this);

        this.OnConsolidaPolizza = this.OnConsolidaPolizza.bind(this);

        this.OnClickConsolidaPolizza = this.OnClickConsolidaPolizza.bind(this);

        this.PopolaFrazionamento();
    }

    private PopolaFrazionamento() {
        this._Frazionamento = {};
        this._Frazionamento["1"] = new Dati.CTipo("4", "Quadrimestrale");
        this._Frazionamento["2"] = new Dati.CTipo("6", "Semestrale");
        this._Frazionamento["3"] = new Dati.CTipo("12", "Annuale");
    }

    static getDerivedStateFromProps(props: Glob.IRouteGlobaleProps, state: IRCPComparatoreNewState): IRCPComparatoreNewState {
        state.ID_Polizza = (props.match.params as any).ID_Polizza;
        return state;
    }

    private OnRisSelezioneProdotto(sender: ChiamaAPI, dati: Dati.CRisAPI, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            //console.warn("DATI", dati);
            let DatiTipoProdotto: Dati.CDatiTipoProdotto = JSON.parse(dati.MessaggioDati);
            this.setState({ DatiTipoProdotto: DatiTipoProdotto });
        }
        return false;
    }

    private OnModificaURLDatiProdotto(e: any, v: any): any {
        Glob.AvviaCaricamento(Trad.Trad("Caricamento dati polizza"));
        if (v != undefined && String(v) != "") {
            this._URLInfoProdotto = this._URLInfoProdottoBase + String(v);
        } else {
            this._URLInfoProdotto = this._URLInfoProdottoBase + "0";
        }

        this._URLDatiProdottoIncremento = this._URLDatiProdottoIncremento + 1;

        return v;
    }

    private OnRisDatiProdotto(sender: ChiamaAPI, dati: DatiRCP.CRisAPIDatoTipiInfo_Comparatore, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && this.state.Dati.Dato.ID_Polizza == 0 /*&& this.state.Dati.Dato.ID_TipoProdotto > 0*/) {
            let datiPolizzaVuota: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
            datiPolizzaVuota.Info = dati.Info;
            datiPolizzaVuota.Dato = this.state.Dati.Dato;
            let nuovaPolizza: any = Glob.CreaClassePolizzaRCP(dati.Info);
            this.setState({ Dati: datiPolizzaVuota, DatoRCPPolizza: nuovaPolizza });
        }

        return false;
    }

    private OnChangeGaranzia(e: React.FormEvent<any> | string, valore?: any): void {
        if (valore != undefined) {
            this.OnChange(e, valore);
        }
    }

    private OnRisProdotto(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && this.state.ID_Polizza == 0) {
            this.PopolaProdotti(dati, false);
        }
        return false;
    }

    private OnRisCalcolaPolizze(sender: ChiamaAPI, dati: DatiRCP.CRisAPIRCPInfo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (this.state.GaranzieJSON.toString() != "") {
                dati.Garanzie = JSON.parse(this.state.GaranzieJSON);
                //console.warn("OnRisCalcolaPolizze", dati, this.state.PolizzeJSON);
            }
            //console.warn("OnRisCalcolaPolizze", dati);
            this.PopolaProdotti(dati, true);
        }
        return false;
    }

    private PopolaProdotti(dati: DatiRCP.CRisAPIRCPInfo, saveCastelletto?: boolean): void {
        if (dati.Polizze != undefined) {
            let Errore: boolean = false;
            let prodotti: DatiRCP.CProdotto[] = [];
            for (let i: number = 0; i < dati.Polizze.length; i++) {
                //Selezaiono le polizze
                if (dati.Polizze[i].Errore) Errore = true;

                if (dati.Polizze[i].Dati[0] != undefined && dati.Polizze[i].Dati[0].ID_Binder > 0 && dati.Polizze[i].Dati[0].ID_TipoGaranzia != dati.Polizze[i].Dati[0].NomeClasseGaranzia) {
                    let prodotto: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                    prodotto.ID_Binder = dati.Polizze[i].Dati[0].ID_Binder;
                    prodotto.ID_BinderCompagnia = dati.Polizze[i].Dati[0].ID_BinderCompagnia;
                    prodotto.ID_AnagCompagniaBinder = dati.Polizze[i].Dati[0].ID_AnagCompagniaBinder;
                    prodotto.Compagnia = dati.Polizze[i].Dati[0].Compagnia; //Garanzia base
                    prodotto.Logo = "";
                    prodotto.LimiteAccessori = dati.Polizze[i].Dati[0].LimiteAccessori;
                    prodotto.LimiteFlessibilita = dati.Polizze[i].Dati[0].LimiteFlessibilita;
                    prodotto.Scoperto = dati.Polizze[i].Dati[0].Scoperto;
                    prodotto.ScopertoMin = dati.Polizze[i].Dati[0].ScopertoMin;
                    prodotto.ScopertoMax = dati.Polizze[i].Dati[0].ScopertoMax;

                    prodotto.PremioNettoMaggiorato = dati.Polizze[i].Dati[0].PremioNettoMaggiorato;
                    prodotto.Accessori = dati.Polizze[i].Dati[0].Accessori;
                    prodotto.Flessibilita = dati.Polizze[i].Dati[0].Flessibilita;

                    let garanzia: DatiRCP.CGaranzia = new CGaranzia();
                    garanzia.Abilitata = !dati.Polizze[i].Dati[0].Errore;
                    if (dati.Polizze[i].Dati[0].Semaforo == DatiRCP.SemaforoRosso) {
                        garanzia.Abilitata = false;
                    }
                    garanzia.Semaforo = dati.Polizze[i].Dati[0].Semaforo;
                    garanzia.Base = true;
                    garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[0].ID_TipoGaranzia;
                    garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[0].NomeClasseGaranzia;
                    garanzia.ImportoLordo = dati.Polizze[i].Dati[0].ImportoLordo;
                    garanzia.ImportoNetto = dati.Polizze[i].Dati[0].ImportoNetto;
                    garanzia.Messaggio = dati.Polizze[i].Dati[0].Messaggio;
                    garanzia.Dati = dati.Polizze[i].Dati[0].Dati;

                    prodotto.GaranziaBase = garanzia;
                    prodotto.GaranzieAccessorie = [];

                    for (let x: number = 1; x < dati.Polizze[i].Dati.length; x++) {
                        //Garanzie accessorie per questo parto da 1
                        let garanzia: DatiRCP.CGaranzia = new CGaranzia();
                        garanzia.Abilitata = !dati.Polizze[i].Dati[x].Errore;
                        if (dati.Polizze[i].Dati[x].Semaforo == DatiRCP.SemaforoRosso) {
                            garanzia.Abilitata = false;
                        }
                        garanzia.Semaforo = dati.Polizze[i].Dati[x].Semaforo;
                        garanzia.Base = false;
                        garanzia.ID_TipoGaranzia = dati.Polizze[i].Dati[x].ID_TipoGaranzia;
                        garanzia.NomeClasseGaranzia = dati.Polizze[i].Dati[x].NomeClasseGaranzia;
                        garanzia.ImportoLordo = dati.Polizze[i].Dati[x].ImportoLordo;
                        garanzia.ImportoNetto = dati.Polizze[i].Dati[x].ImportoNetto;
                        garanzia.Messaggio = dati.Polizze[i].Dati[x].Messaggio;
                        garanzia.Dati = dati.Polizze[i].Dati[x].Dati;
                        prodotto.GaranzieAccessorie.push(garanzia);
                    }

                    if (saveCastelletto) {
                        let tmpPolizze: DatiRCP.CProdotto[] = [];
                        if (typeof this.state.PolizzeJSON == "string") {
                            tmpPolizze = JSON.parse(this.state.PolizzeJSON);
                        } else {
                            tmpPolizze = this.state.PolizzeJSON;
                        }

                        let tmpPolizza: DatiRCP.CProdotto = new DatiRCP.CProdotto();
                        tmpPolizza = tmpPolizze[tmpPolizze.findIndex(p => p.ID_BinderCompagnia == dati.Polizze[i].Dati[0].ID_BinderCompagnia)];

                        if (tmpPolizza != undefined) {
                            if (
                                typeof tmpPolizza.CalcolaImportoNettoTotale == "function" &&
                                tmpPolizza.PremioNettoMaggiorato != tmpPolizza.CalcolaImportoNettoTotale() &&
                                tmpPolizza.PremioNettoMaggiorato > prodotto.CalcolaImportoNettoTotale()
                            )
                                //Lo tengo solo se era stato impostato dall'utente
                                prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;

                            prodotto.Accessori = tmpPolizza.Accessori;
                            prodotto.Flessibilita = tmpPolizza.Flessibilita;
                            //prodotto.PremioNettoMaggiorato = tmpPolizza.PremioNettoMaggiorato;
                            prodotto.GaranziaBase.Selezionata = tmpPolizza.GaranziaBase.Selezionata;
                        }
                    }
                    //console.warn("PRODOTTO", prodotto, this.state.PolizzeJSON);
                    prodotti.push(prodotto);
                }
            }

            if (prodotti.length > 0 && !Errore) {
                //console.warn("PRODOTTI", prodotti);
                //console.warn("PRODOTTI A", prodotti, JSON.stringify(prodotti), this.state.PolizzeJSON, "GARANZIE", dati.Garanzie);
                //console.warn("PRODOTTI", prodotti, dati);
                this.setState({ PolizzeJSON: JSON.stringify(prodotti), GaranzieJSON: JSON.stringify(dati.Garanzie) });
            }
        }
    }

    private OnInvioCalcola(sender: ChiamaAPI): any {
        let DatiAssociati: DatiRCP.CComparatoreSingolo[] = [];

        if (typeof this.state.DatiAssociati == "string") DatiAssociati = JSON.parse(this.state.DatiAssociati);
        else DatiAssociati = this.state.DatiAssociati;

        let Polizze: any;

        //if (DatiAssociati.length <= 0)
        //    Polizze = new DatiRCP.CRCPPolizze();
        //else
        //    Polizze = new DatiRCP.CRCPPolizzeStudiAssociati();

        Polizze = new DatiRCP.CRCPPolizzeStudiAssociati();

        let appPolizze = new DatiRCP.CRCPPolizze();
        //console.warn("CONTROLLO", this.PreparaPolizza(this.state.PolizzeJSON, this.state.GaranzieJSON, this.state.DatoRCPPolizza));
        appPolizze = this.PreparaPolizza(this.state.PolizzeJSON, this.state.GaranzieJSON, this.state.DatoRCPPolizza);

        //console.warn("appPolizze", appPolizze, this.state.PolizzeJSON);

        Polizze.Parametri = appPolizze.Parametri;
        Polizze.Polizze = appPolizze.Polizze;

        for (let i: number = 0; i < DatiAssociati.length; i++)
            Polizze.PolizzeAssociati.push(this.PreparaPolizza(DatiAssociati[i].PolizzeJSON, DatiAssociati[i].GaranzieJSON, DatiAssociati[i].DatoRCPPolizza));

        if (typeof this.state.DatoRCPPolizza == "object") Polizze.Parametri["Frazionamento"] = this.state.Frazionamento;

        //console.warn("CIAO CIAO", Polizze);
        //console.warn("OnInvioCalcola", Polizze);
        //console.warn("Polizze", DatiAssociati, this.state.PolizzeJSON, appPolizze, Polizze);

        return Polizze;
    }

    private PreparaPolizza(polizzeJSON: Glob.DatiJSON | any, garanzieJSON: Glob.DatiJSON | any, datoRCPPolizza: any): DatiRCP.CRCPPolizze {
        let Polizze: DatiRCP.CRCPPolizze = new DatiRCP.CRCPPolizze();
        let polizzeApp: DatiRCP.CProdotto[] = [];

        if (polizzeJSON.toString() != "") {
            if (typeof polizzeJSON == "string") polizzeApp = JSON.parse(polizzeJSON);
            else polizzeApp = polizzeJSON;
        }

        let garanzieApp: DatiRCP.CCampoGaranziaVisualizzazione[] = [];

        if (garanzieJSON.toString() != "") {
            if (typeof garanzieJSON == "string") garanzieApp = JSON.parse(garanzieJSON);
            else garanzieApp = garanzieJSON;
        }

        for (let i: number = 0; i < polizzeApp.length; i++) {
            let polizzaApp: DatiRCP.CRCPPolizza = new DatiRCP.CRCPPolizza();
            polizzaApp.ID_Binder = polizzeApp[i].ID_Binder;
            polizzaApp.ID_BinderCompagnia = polizzeApp[i].ID_BinderCompagnia;
            polizzaApp.ID_AnagCompagniaBinder = polizzeApp[i].ID_AnagCompagniaBinder;
            polizzaApp.Compagnia = polizzeApp[i].Compagnia;
            polizzaApp.ImportoLordo = polizzeApp[i].GaranziaBase.ImportoLordo;
            polizzaApp.ImportoNetto = polizzeApp[i].GaranziaBase.ImportoNetto;
            polizzaApp.ID_TipoGaranzia = polizzeApp[i].GaranziaBase.ID_TipoGaranzia;
            polizzaApp.NomeClasseGaranzia = polizzeApp[i].GaranziaBase.NomeClasseGaranzia;

            polizzaApp.LimiteAccessori = polizzeApp[i].LimiteAccessori;
            polizzaApp.LimiteFlessibilita = polizzeApp[i].LimiteFlessibilita;

            polizzaApp.Scoperto = polizzeApp[i].Scoperto;
            polizzaApp.ScopertoMin = polizzeApp[i].ScopertoMin;
            polizzaApp.ScopertoMax = polizzeApp[i].ScopertoMax;

            for (let x: number = 0; x < garanzieApp.length; x++) {
                if (garanzieApp[x].Selezionata) {
                    let garanziaApp: DatiRCP.CRCPGaranzia = new DatiRCP.CRCPGaranzia();
                    garanziaApp.ID_TipoGaranzia = garanzieApp[x].ID_TipoGaranzia;
                    garanziaApp.NomeClasseGaranzia = garanzieApp[x].NomeClasseGaranzia[polizzaApp.Compagnia];

                    polizzaApp.Garanzie.push(garanziaApp);
                }
            }

            Polizze.Polizze.push(polizzaApp);
        }
        Polizze.Parametri = datoRCPPolizza;

        return Polizze;
    }

    private OnRisRecuperaPreventivo(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                if (dati.ID_Chiave > 0) {
                    let DatiApp: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = new DatiRCP.CRisAPIDatoTipiInfo_Comparatore();
                    DatiApp.Dato.DatiPolizza = dati.Dato.DatiPolizza;

                    //console.warn("CONTROLLO", dati.Dato.DatiPolizza);
                    let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
                    DatiPolizza = JSON.parse(dati.Dato.DatiPolizza);

                    this.setState(
                        {
                            Dati: dati,
                            ID_Polizza: dati.ID_Chiave,
                            DatoRCPPolizza: DatiPolizza.DatoRCPPolizza,
                            PolizzeJSON: JSON.stringify(DatiPolizza.Polizze),
                            GaranzieJSON: JSON.stringify(DatiPolizza.Garanzie),
                            FileJSON: dati.Dato.FileJSON,
                            DatiAssociati: JSON.stringify(DatiPolizza.DatiAssociati)
                        },
                        () => {
                            //this.PopolaGaranzie(DatiPolizza.Garanzie)
                        }
                    );
                }
            } else {
                Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
            }
        }
        return true;
    }

    private AbilitaModifica() {
        if (this.state.Dati.Tipi.PolizzaStato != undefined) {
            let Permesso: string[] = this.state.Dati.Tipi.PolizzaStato[Glob.Tipi_PS_Consolidata].Permesso || [];
            if (
                this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo ||
                (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore && Permesso.indexOf(Glob.Tipi_PS_ConsolidataSottoscrittore) > -1)
            ) {
                this._AbilitaModifica = true;
            } else {
                this._AbilitaModifica = false;
            }
        }
    }

    private OnRisRegola(sender: ChiamaAPI, dati: Dati.CRisAPISemplice<string>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._Regole = dati.Dato;
        }
        return true;
    }

    private OnChangeDataEffetto(e: React.FormEvent<any> | string, valore?: any): void {
        let DataEffetto: Data.CData = new Data.CData();
        let DataScadenza: Data.CData = new Data.CData();
        if (typeof e == "string") {
            DataEffetto = new Data.CData(valore);
        } else {
            DataEffetto = new Data.CData(e.currentTarget.value);
        }
        DataScadenza = new Data.CData(DataEffetto.Data);
        DataScadenza.AddAnni(1);
        this.OnChange("Dato.DataFine", DataScadenza.Data);
        this.OnChange(e, valore);
    }

    private OnChangeAnagrafica(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof e == "string" && e == "Dato.ID_AnagContraente") {
            if (valore == 0 || valore == "") {
                this.OnChange("AnagraficaJSON", "");
                this.OnChange("DatiProfessionaliJSON", "");
                this.OnChange("IndirizziJSON", "");
                this.OnChange("RecapitiJSON", "");
            }
        }
        this.OnChange(e, valore);
    }

    private OnRisAnagrafica(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Anag, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_Anag > 0) {
                this.setState({
                    AnagraficaJSON: JSON.stringify(dati.Dato),
                    RecapitiJSON: dati.Dato.RecapitiJSON,
                    IndirizziJSON: dati.Dato.IndirizziJSON,
                    DatiProfessionaliJSON: dati.Dato.DatiProfessionaliJSON
                });
            }
        }
        return false;
    }

    private OnInvioSalvaPolizza(sender: BottoneAPI): any {
        //console.warn("STATE", this.state);
        //this.RegoleCheck(this.state);
        //return false;
        if (this.state.Dati.Dato.ID_AnagContraente == 0) {
            Glob.InfoModaleWarning(Trad.Trad("POLIZZA"), Trad.Trad("SelezionareAnagraficaContraente"));
            return false;
        }

        if (this.state.Dati.Dato.ID_TipoProdotto == 0) {
            Glob.InfoModaleWarning(Trad.Trad("POLIZZA"), Trad.Trad("SelezionareProfessione"));
            return false;
        }

        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        Ingr.Dato = this.state.Dati.Dato;
        Ingr.Dato.ID_AnagContraente = this.state.Dati.Dato.ID_AnagContraente;
        Ingr.Dato.ID_Polizza = this.state.ID_Polizza;

        if (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore) Ingr.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_ConsolidataSottoscrittore;
        else Ingr.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_Preventivo;

        Ingr.Dato.ID_TipoRamo = Glob.TipiRami_RCP; //RCP

        Ingr.Dato.ID_AnagPOS = Glob.GetSessione().ID_Anag;

        if (typeof this.state.FileJSON == "string") Ingr.Dato.FileJSON = this.state.FileJSON;
        else Ingr.Dato.FileJSON = JSON.stringify(this.state.FileJSON);

        let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
        if (typeof this.state.DatoRCPPolizza == "string") DatiPolizza.DatoRCPPolizza = JSON.parse(this.state.DatoRCPPolizza);
        else DatiPolizza.DatoRCPPolizza = this.state.DatoRCPPolizza;

        if (typeof this.state.PolizzeJSON == "string") DatiPolizza.Polizze = JSON.parse(this.state.PolizzeJSON);
        else DatiPolizza.Polizze = this.state.PolizzeJSON;

        if (typeof this.state.GaranzieJSON == "string") DatiPolizza.Garanzie = JSON.parse(this.state.GaranzieJSON);
        else DatiPolizza.Garanzie = this.state.GaranzieJSON;

        if (typeof this.state.DatiAssociati == "string") DatiPolizza.DatiAssociati = JSON.parse(this.state.DatiAssociati);
        else DatiPolizza.DatiAssociati = this.state.DatiAssociati;

        //Pulizia ed ordinamento
        for (let i: number = 0; i < DatiPolizza.DatiAssociati.length; i++) {
            if (typeof DatiPolizza.DatiAssociati[i].PolizzeJSON == "string") DatiPolizza.DatiAssociati[i].PolizzeJSON = JSON.parse(DatiPolizza.DatiAssociati[i].PolizzeJSON);

            if (typeof DatiPolizza.DatiAssociati[i].GaranzieJSON == "string") DatiPolizza.DatiAssociati[i].GaranzieJSON = JSON.parse(DatiPolizza.DatiAssociati[i].GaranzieJSON);

            //CampiPolizza è di struttura, non serve nei dati da salvare
            delete DatiPolizza.DatiAssociati[i].CampiPolizza;
        }

        DatiPolizza.Frazionamento = this.state.Frazionamento;

        Ingr.Dato.DatiPolizza = JSON.stringify(DatiPolizza);

        return Ingr;
    }

    private OnClickSalvaPolizza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        } else {
            this.setState({ ID_Polizza: dati.ID_Chiave });
            this.state.Dati.Dato.Polizza = dati.MessaggioTesto; //Aggiorno il numero di polizza
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo salvato correttamente con ID: {1-S}", [dati.ID_Chiave]));

            if ((this.props.match.params as any).ID_Anag != undefined) {
                this.props.history.replace("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/RCPComparatoreNew/" + dati.ID_Chiave);
            } else {
                this.props.history.replace("/RCPComparatoreNew/" + dati.ID_Chiave);
            }
        }
    }

    private OnConsolidaPolizza(sender: BottoneAPI, tipoConsolidamento: string): any {
        this._TipoConsolidamento = "";
        if (!this.RegoleCheck(this.state)) {
            var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
            Ingr = this.OnInvioSalvaPolizza(sender);
            Ingr.Dato.ID_TipoPolizzaStato = tipoConsolidamento;
            Ingr.Dato.CoAssicurazioneJSON = "";
            this._TipoConsolidamento = tipoConsolidamento;
            return Ingr;
        } else {
            return false;
        }
    }

    private OnClickConsolidaPolizza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this.setState({ ID_Polizza: dati.ID_Chiave });
            let app: DatiRCP.CRisAPIDatoTipiInfo_Comparatore = this.state.Dati;
            app.Dato.Polizza = dati.MessaggioTesto; //Aggiorno il numero di polizza;
            if (this._TipoConsolidamento != "") app.Dato.ID_TipoPolizzaStato = this._TipoConsolidamento;

            this.setState({ Dati: app });

            if ((this.props.match.params as any).ID_Anag != undefined) {
                this.props.history.push("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/RCPPolizza/" + dati.ID_Chiave);
            } else {
                this.props.history.push("/RCPPolizza/" + dati.ID_Chiave);
            }
        }
    }

    public render() {
        let DifferenzeTMP: number = this.state.GaranzieJSON.length + JSON.stringify(this.state.DatoRCPPolizza).length + JSON.stringify(this.state.DatiAssociati).length + this.state.Frazionamento;

        if (this._Differenze != DifferenzeTMP) {
            this._Differenze = DifferenzeTMP;
            this._CalcolaRCP++;
        }

        if (!this.ControlloAutorizzazione("RCPComparatoreController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        this.AbilitaModifica();

        let chiavi: number[] = [];

        chiavi.push(this.state.ID_Polizza);
        chiavi.push(this.state.Dati.Dato.ID_AnagContraente);

        let DatiAnagrafica: Dati.CAnagrafica = new Dati.CAnagrafica();
        if (this.state.AnagraficaJSON != "") {
            DatiAnagrafica = JSON.parse(this.state.AnagraficaJSON);
        }

        //console.warn("RENDER N:", new Date().getTime(), this.state);

        let Comparatore: any = <div></div>;

        let DatiPolizza: DatiRCP.CComparatoreSingolo = new DatiRCP.CComparatoreSingolo();
        DatiPolizza.DatoRCPPolizza = this.state.DatoRCPPolizza;
        DatiPolizza.GaranzieJSON = this.state.GaranzieJSON;
        DatiPolizza.PolizzeJSON = this.state.PolizzeJSON;
        DatiPolizza.CampiPolizza = this.state.Dati.Info;

        //console.warn("APP", DatiPolizza);

        if (this.state.DatiTipoProdotto.ID_TipiProdotti == undefined || (this.state.DatiTipoProdotto.ID_TipiProdotti.length > 0 && this.state.DatiTipoProdotto.ID_TipiProdotti.length < 2)) {
            Comparatore = (
                <ComparatoreProfessioneSingola
                    Id="DatiPolizza"
                    Name="DatiPolizza"
                    OnChange={this.OnChange}
                    OnChangeGaranzia={this.OnChangeGaranzia}
                    ID_Polizza={this.state.ID_Polizza}
                    ID_TipoPolizzaStato={this.state.Dati.Dato.ID_TipoPolizzaStato}
                    AbilitaModifica={this._AbilitaModifica}
                    Frazionamento={this.state.Frazionamento}
                    DatiPolizza={DatiPolizza}
                    ID_GaranzieJSON="GaranzieJSON"
                    ID_PolizzeJSON="PolizzeJSON"
                    ID_DatoRCPPolizza="DatoRCPPolizza"
                />
            );
        } else if (this.state.DatiTipoProdotto.ID_TipiProdotti != undefined && this.state.DatiTipoProdotto.ID_TipiProdotti.length > 1) {
            Comparatore = (
                <ComparatoreStudioAssociato
                    Id="DatiAssociati"
                    Name="DatiAssociati"
                    OnChange={this.OnChange}
                    OnChangeGaranzia={this.OnChangeGaranzia}
                    ID_Polizza={this.state.ID_Polizza}
                    ID_TipoPolizzaStato={this.state.Dati.Dato.ID_TipoPolizzaStato}
                    AbilitaModifica={this._AbilitaModifica}
                    Frazionamento={this.state.Frazionamento}
                    DatiPolizze={this.state.DatiAssociati}
                    DatiPolizza={DatiPolizza}
                    ID_TipiProdotti={this.state.DatiTipoProdotto.ID_TipiProdotti}
                />
            );
        } else {
            Comparatore = <div></div>;
        }

        return (
            <div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <span className="kt-portlet__head-icon">
                                    <i className="fa fa-balance-scale"></i>
                                </span>
                                <h3 className="kt-portlet__head-label">{Trad.Trad("Comparatore RCP")}</h3>
                            </div>
                        </div>
                        <div className="portlet__head-tools">
                            <ul className="kt-portlet__nav">
                                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true"></div>
                            </ul>
                        </div>
                    </div>
                    <form className="kt-form login-form kt-form login-form--label-align-left- kt-form login-form--state-" id="kt_form" noValidate>
                        <div className="kt-portlet__body">
                            <div className="kt-wizard__form-step kt-wizard__form-step--current" id="kt_wizard_form_step_4">
                                <div className="row">
                                    <div className="col-xl-10 offset-xl-1">
                                        <div className="kt-form login-form__section kt-form login-form__section--first">
                                            <div className="kt-form login-form__heading">
                                                <h3 className="kt-form login-form__heading-title">{Trad.Trad("Information")}</h3>
                                            </div>
                                            <div className="form-group kt-form login-form__group row">
                                                <div className="col-lg-4 kt-form login-form__group-sub">
                                                    <label className="form-control-label">{Trad.Trad("Professione")}</label>
                                                    <Tipo
                                                        Campo="Dato.ID_TipoProdotto"
                                                        ID_ChiaveString={this.state.Dati.Dato.ID_TipoProdotto.toString() || ""}
                                                        OnAggiorna={(e, v) => {
                                                            this.OnChange(e, this.OnModificaURLDatiProdotto(e, v));
                                                        }}
                                                        URL="/api/Tipi/Tipo?tabella=TipiProdottiRCP&campo=TipoProdotto&parametri=X"
                                                        Disabilitato={this.state.ID_Polizza > 0}
                                                        Ordinato={true}
                                                    />
                                                </div>
                                            </div>
                                            <CampiPolizza
                                                Gruppo="Livello1"
                                                Riga={1}
                                                Info={this.state.Dati.Info}
                                                DatoPolizza={this.state.DatoRCPPolizza}
                                                Identificatore="DatoRCPPolizza"
                                                Limiti={{}}
                                                OnChange={(e, v) => {
                                                    this.OnChange(e, v);
                                                    //this.OnChangeGaranzia(e, undefined)
                                                }}
                                                OnChangeDeroga={() => {}}
                                                OnBlur={() => {}}
                                                DimensioneGrafica={3}
                                                Abilitato={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />

                                <div className="accordion accordion-solid accordion-toggle-plus" id="kt_accordion_1" role="tablist">
                                    {Comparatore}
                                    <div className="card overflow-visible">
                                        <AccordionAnagrafica
                                            AnagraficaJSON={this.state.AnagraficaJSON}
                                            AnagraficaId="AnagraficaJSON"
                                            AnagraficaName="AnagraficaJSON"
                                            DatiProfessionaliJSON={this.state.DatiProfessionaliJSON}
                                            DatiProfessionaliId="DatiProfessionaliJSON"
                                            DatiProfessionaliName="DatiProfessionaliJSON"
                                            IndirizziJSON={this.state.IndirizziJSON}
                                            IndirizziId="IndirizziJSON"
                                            IndirizziName="IndirizziJSON"
                                            RecapitiJSON={this.state.RecapitiJSON}
                                            RecapitiId="RecapitiJSON"
                                            RecapitiName="RecapitiJSON"
                                            OnChange={this.OnChangeAnagrafica}
                                            Indice={4}
                                            Id="Anagrafica"
                                            Name="Anagrafica"
                                            CampoTipo="Dato.ID_AnagContraente"
                                            ID_AnagContraente={this.state.Dati.Dato.ID_AnagContraente}
                                            ID_TipoProdotto={this.state.Dati.Dato.ID_TipoProdotto}
                                            CampoIDAnagrafica="Dati.Dato.ID_AnagContraente"
                                            ID_TipoAnagPrincipale="DatiAnagrafica.ID_TipoAnagPrincipale"
                                            StatoAnagrafica={Glob.Tipi_AS_Attivo}
                                        />
                                    </div>
                                    <div className="card overflow-visible">
                                        <div className="card-header">
                                            <a
                                                href="#kt_accordion_1_item_5_body"
                                                className="card-title collapsed"
                                                role="tab"
                                                id="kt_accordion_1_item_5_head"
                                                data-toggle="collapse"
                                                aria-expanded="false"
                                            >
                                                <span className="accordion__item-icon">
                                                    <i className="fa fa-feather-alt"></i>
                                                </span>
                                                <span className="accordion__item-icon">{Trad.Trad("DatiEmissione")}</span>
                                                <span className="kt-accordion__item-mode"></span>
                                            </a>
                                            <div
                                                className="kt-accordion__itekt-body collapse spazioVerticale"
                                                id="kt_accordion_1_item_5_body"
                                                role="tabpanel"
                                                aria-labelledby="kt_accordion_1_item_5_head"
                                                data-parent="#kt_accordion_1"
                                            >
                                                <div className="tab-content kt--padding-30">
                                                    <div className="form-group special-group kt-form login-form__group row">
                                                        <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                            <InputData
                                                                ValoreInArrivo={this.state.ID_Polizza > 0}
                                                                Name="Dato.DataEffetto"
                                                                Id="Dato.DataEffetto"
                                                                Valore={this.state.Dati.Dato.DataEffetto}
                                                                OnChange={this.OnChangeDataEffetto}
                                                                Etichetta="DataEffetto"
                                                                DataMinima={moment().add(-30, "day").toDate()}
                                                                DataMassima={moment().add(30, "day").toDate()}
                                                            />
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                            <InputData
                                                                ValoreInArrivo={this.state.ID_Polizza > 0}
                                                                Name="Dato.DataFine"
                                                                Id="Dato.DataFine"
                                                                Valore={this.state.Dati.Dato.DataFine}
                                                                OnChange={this.OnChange}
                                                                Etichetta="DataScadenza"
                                                            />
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                                                            <label className="">{Trad.Trad("Frazionamento")}</label>
                                                            <Tipo
                                                                Campo="Frazionamento"
                                                                ID_ChiaveString={this.state.Frazionamento.toString() || ""}
                                                                OnAggiorna={(e, v) => {
                                                                    this.OnChange(e, v);
                                                                    this.OnChangeGaranzia(e, undefined);
                                                                }}
                                                                Dati={this._Frazionamento}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header">
                                            <a
                                                href="#kt_accordion_1_item_6_body"
                                                className="card-title collapsed"
                                                role="tab"
                                                id="kt_accordion_1_item_6_head"
                                                data-toggle="collapse"
                                                aria-expanded="false"
                                            >
                                                <span className="accordion__item-icon">
                                                    <i className="fa fa-highlighter"></i>
                                                </span>
                                                <span className="accordion__item-icon">{Trad.Trad("InformazioniAccessorie")}</span>
                                                <span className="kt-accordion__item-mode"></span>
                                            </a>
                                            <div
                                                className="kt-accordion__itekt-body collapse"
                                                id="kt_accordion_1_item_6_body"
                                                role="tabpanel"
                                                aria-labelledby="kt_accordion_1_item_6_head"
                                                data-parent="#kt_accordion_1"
                                            >
                                                <div className="tab-content  kt--padding-60">
                                                    <div>
                                                        <div className="col-xl-12 offset-xl-0">
                                                            <div className="kt-form kt-padding-30 login-form__section kt-form login-form__section--first">
                                                                <CheckListFile
                                                                    Aggiornare={this.state.Dati.Dato.ID_Polizza}
                                                                    Id="FileJSON"
                                                                    Name="FileJSON"
                                                                    ID_Chiave={this.state.Dati.Dato.ID_Polizza}
                                                                    ChiaviRecupero={chiavi}
                                                                    ID_TipoFileRichiesto={this.state.Dati.Dato.ID_TipoFileRichiesto || ""}
                                                                    Value={this.state.FileJSON}
                                                                    OnChange={this.OnChange}
                                                                    Validato={false}
                                                                    Visibile={this.state.Dati.Dato.ID_Polizza > 0}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__foot kt-portlet__foot--fit">
                            <div className="kt-form login-form__actions kt-form login-form__actions--left">
                                <div className="col kt-form__actions kt-form__actions--left">
                                    <div className="col-lg-12 kt--align-left">
                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this._AbilitaModifica}
                                                Alt={Trad.Trad("Salva")}
                                                Icona="fa fa-save"
                                                Testo={Trad.Trad("Salva")}
                                                ClasseAttivo="btn btn-brand"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL="/api/polizza/salvapolizza"
                                                Metodo="POST"
                                                OnInvio={s => this.OnInvioSalvaPolizza(s)}
                                                OnClick={(s, d) => this.OnClickSalvaPolizza(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={this._Scrittura}
                                            />
                                        </div>

                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo}
                                                Alt={Trad.Trad("Consolida sottoscrittore")}
                                                Icona="fa fa-book-reader"
                                                Testo={Trad.Trad("Consolida sottoscrittore")}
                                                ClasseAttivo="btn btn-warning"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL="/api/polizza/salvapolizza"
                                                Metodo="POST"
                                                OnInvio={s => this.OnConsolidaPolizza(s, Glob.Tipi_PS_ConsolidataSottoscrittore)}
                                                OnClick={(s, d) => this.OnClickConsolidaPolizza(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={this._Scrittura && this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo}
                                            />
                                        </div>

                                        <div className="divtabella">
                                            <BottoneAPI
                                                Attivo={this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo || this._AbilitaModifica}
                                                Alt={Trad.Trad("Consolida compagnia")}
                                                Icona="fa fa-inbox"
                                                Testo={Trad.Trad("Consolida compagnia")}
                                                ClasseAttivo="btn btn-success"
                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                URL="/api/polizza/salvapolizza"
                                                Metodo="POST"
                                                OnInvio={s => this.OnConsolidaPolizza(s, Glob.Tipi_PS_Consolidata)}
                                                OnClick={(s, d) => this.OnClickConsolidaPolizza(s, d)}
                                                OnErrore={(s, e) => this.OnErrore(s, e)}
                                                Visibile={
                                                    this._Scrittura &&
                                                    (this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo ||
                                                        this.state.Dati.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_TipoProdotto}
                            URL={"/api/Tipi/GetDatiTipoProdotto?sessione=" + Glob.GetSessione().Sessione + "&id_TipoProdotto=" + this.state.Dati.Dato.ID_TipoProdotto.toString()}
                            OnRis={(s, d, dn) => this.OnRisSelezioneProdotto(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_AnagContraente}
                            URL={"/api/anag/seleziona?id_Anag=" + this.state.Dati.Dato.ID_AnagContraente}
                            OnRis={(s, d, dn) => this.OnRisAnagrafica(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI Aggiornare={this._URLDatiProdottoIncremento} URL={this._URLInfoProdotto} OnRis={(s, d, dn) => this.OnRisDatiProdotto(s, d, dn)} OnErrore={this.OnErrore} />
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_TipoProdotto}
                            URL={"/api/Polizza/GetGaranzieRCP?ID_TipoProdotto=" + this.state.Dati.Dato.ID_TipoProdotto.toString()}
                            OnRis={(s, d, dn) => this.OnRisProdotto(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this._CalcolaRCP}
                            URL={"/api/Polizza/CalcolaPreventiviRCP"}
                            OnInvio={s => this.OnInvioCalcola(s)}
                            OnRis={(s, d, dn) => this.OnRisCalcolaPolizze(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this.state.ID_Polizza}
                            URL={"/api/polizza/?id_Polizza=" + this.state.ID_Polizza + "&id_AnagContraente=" + this.state.Dati.Dato.ID_AnagContraente}
                            OnRis={(s, d, dn) => this.OnRisRecuperaPreventivo(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <ChiamaAPI
                            Aggiornare={this.state.Dati.Dato.ID_TipoProdotto}
                            URL={"/api/regole/Get?id_Regola=Regola" + this.state.Dati.Dato.ID_TipoProdotto.toString()}
                            OnRis={(s, d, dn) => this.OnRisRegola(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                        <input type="checkbox" name="PreventivoSelezionato" id="PreventivoSelezionato" className="hidden" readOnly={true} checked={this.state.PreventivoSelezionato} />
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/RCPComparatoreNew.tsx